import { type ComponentPropsWithoutRef, type FC } from 'react';
import { ScrollArea as ShadcnScrollArea } from './ui/scroll-area';

export type ScrollAreaProps = ComponentPropsWithoutRef<typeof ShadcnScrollArea>;

/**
 * Thin wrapper — no Figma design. Swaps plain `overflow` scrolling for a styled
 * scrollbar that stays legible on both light and dark (including video) surfaces.
 */
export const ScrollArea: FC<ScrollAreaProps> = (props) => <ShadcnScrollArea {...props} />;

export { ScrollBar } from './ui/scroll-area';
